import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-32 border-t border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-12 gap-8 items-start">
        {/* Brand */}
        <div className="col-span-12 md:col-span-5 lg:col-span-4">
          <div className="flex items-center gap-3">
            <span className="w-2 h-2 rounded-full bg-[#9DB4FF]" />
            <span className="flex flex-col leading-none">
              <span className="text-[12px] tracking-[0.45em] uppercase text-[#E8ECF1]">FOREALCO</span>
              <span className="mt-1 text-[9px] tracking-[0.35em] uppercase text-white/40 font-mono">
                Foreign Trade · Real Access
              </span>
            </span>
          </div>
          <p className="mt-6 text-[13px] leading-[1.7] text-white/55 max-w-xs">
            Turning market opportunities into operational reality.
          </p>
          <div className="mt-8">
            <Link
              to="/explore-opportunities"
              data-testid="footer-cta"
              className="text-[10px] tracking-[0.3em] uppercase px-5 py-2.5 border border-[#9DB4FF] text-[#9DB4FF] hover:bg-[#9DB4FF] hover:text-[#0E1116] transition-colors inline-block"
            >
              Explore Opportunities
            </Link>
          </div>
        </div>

        {/* Navigation */}
        <FooterCol
          className="col-span-6 md:col-span-3 lg:col-span-3"
          title="Navigation"
          items={[
            ["Approach", "/approach"],
            ["Markets", "/markets"],
            ["Solutions", "/solutions"],
            ["Network", "/network"],
            ["Insights", "/insights"],
            ["About", "/about"],
          ]}
        />

        {/* Focus Areas */}
        <FooterCol
          className="col-span-6 md:col-span-4 lg:col-span-5"
          title="Focus Areas"
          items={[
            ["Digital Infrastructure", "/markets#focus-digital"],
            ["Trade Coordination", "/markets#focus-trade"],
            ["Public Modernization", "/markets#focus-public"],
            ["Defense Support", "/markets#focus-defense"],
            ["Energy & Infrastructure", "/markets#focus-energy"],
            ["Natural Resources", "/markets#focus-resources"],
          ]}
        />
      </div>

      {/* Bottom row: legal sentence + single Legal link */}
      <div className="border-t border-white/5">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] leading-[1.7] text-white/45">
          <p data-testid="footer-legal-line" className="max-w-3xl">
            © 2026 Forealco. A brand by Erenown. All rights reserved. Information on this website is
            provided for general business purposes and does not constitute professional advice.
          </p>
          <Link
            to="/legal"
            data-testid="footer-legal-link"
            className="shrink-0 text-[10px] tracking-[0.35em] uppercase text-white/55 hover:text-white transition-colors"
          >
            Legal →
          </Link>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items, className = "" }) {
  return (
    <div className={className}>
      <div className="text-[10px] tracking-[0.35em] uppercase text-[#9DB4FF] mb-4 font-mono">
        {title}
      </div>
      <ul className="space-y-2">
        {items.map(([label, to]) => (
          <li key={label}>
            <Link
              to={to}
              data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[12px] text-white/60 hover:text-white transition-colors"
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
